import { createSelector } from 'reselect';
import { get } from 'lodash';
import * as types from './types';

const selector = (state) => get(state, types.SCOPE_CORE);
const requestSelector = (state) => get(state, types.SCOPE_REQUEST);
export default selector;

export const legendsSelector = createSelector(selector, (core) => core.legends);

export const currentBucketSelector = createSelector(selector, (store) => store.bucket);

export const currentTimeSelector = createSelector(selector, (store) => store.time);

export const highlightBucketSelector = createSelector(selector, (store) => store.highlightBucket);

export const errorSelector = createSelector(requestSelector, (store) => ({
  errorCode: store.errorCode,
  errorMsg: store.errorMsg,
}));

export const isFetchingSelector = createSelector(requestSelector, (store) =>
  get(store, 'isFetching'),
);
